import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollHandler = ({ children }) => {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTo(0, 0);
    document.body.scrollTo(0, 0);
  }, [location.pathname]);

  return children;
};

export default ScrollHandler;
